<ng-template #orderItemTemplate>
  <tr>
    <td>
      <span>{{ orderItem.product.name }}</span>
      (<span translate>order-receipt.order-item-row.sku</span>
      <span># {{ orderItem.product.sku }})</span>
      <div *ngIf="isPromoted" class="item-promo">
        <span translate>order-receipt.order-item-row.promotion-label</span>
        <span>{{ promoCodeUse.promoCode.description }}</span>
      </div>
    </td>
    <td>{{ orderItem.priceFormatted }}</td>
    <td>{{ orderItem.quantity }}</td>
    <td>{{ orderItem.totalFormatted }}</td>
  </tr>
</ng-template>
